/**
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
import { defineComponent } from 'vue';
export default defineComponent({
    data() {
        return {
            openedSubmenu: null,
        };
    },
    computed: {
        enabledSubmenuActions() {
            return this.enabledFileActions
                .reduce((record, action) => {
                if (action.parent !== undefined) {
                    if (!record[action.parent]) {
                        record[action.parent] = [];
                    }
                    record[action.parent].push(action);
                }
                return record;
            }, {});
        },
    },
    methods: {
        /**
         * Check if a menu is valid, meaning it is
         * defined and has at least one action
         *
         * @param action The action to check
         */
        isValidMenu(action) {
            return this.enabledSubmenuActions[action.id]?.length > 0;
        },
        async onBackToMenuClick(action) {
            if (!action) {
                return;
            }
            this.openedSubmenu = null;
            // Wait for first render
            await this.$nextTick();
            // Focus the previous menu action button
            this.$nextTick(() => {
                // Focus the action button, test both batch and single action references
                // as this mixin is used in both single and batch actions.
                const menuAction = this.$refs[`action-batch-${action.id}`]?.[0]
                    || this.$refs[`action-${action.id}`]?.[0];
                if (menuAction) {
                    menuAction.$el.querySelector('button')?.focus();
                }
            });
        },
    },
});
